import {useCallback} from "react";
import {toast} from "react-toastify";
import {v4 as uuidv4} from "uuid";

import type {SignalRMessage} from "../../../services/signalR/models/Messages";

const useDefaultHandler = (): ((message: SignalRMessage) => void) => {
  const execute = useCallback((message: SignalRMessage): void => {
    if(message.type && (message.data?.constructionId || message.data?.calculationId)){
      toast(
        `${message.type} - ${message.data.constructionId ?? message.data.calculationId} executed successfully!`,
        {
          toastId: uuidv4(),
        },
      );
    }
  }, []);
  return execute;
};

export default useDefaultHandler;
